import { useEffect, useState } from "react";
import { device, isAndroidApp } from "web_myplann/Utils/device";

const NAVBAR_HIDE_ACK_FALLBACK_MS = 250;

let hideCount = 0;

export const useHideNavbar = (open: boolean): boolean => {
	const [navbarHidden, setNavbarHidden] = useState(false);

	useEffect(() => {
		if (!open) return;
		let cancelled = false;
		hideCount += 1;
		const hidden =
			hideCount === 1
				? device.showNavbar(false).catch(() => {})
				: Promise.resolve();
		Promise.race([
			hidden,
			new Promise((resolve) => {
				setTimeout(resolve, NAVBAR_HIDE_ACK_FALLBACK_MS);
			}),
		]).then(() => {
			if (!cancelled) {
				setNavbarHidden(true);
			}
		});
		return () => {
			cancelled = true;
			setNavbarHidden(false);
			hideCount -= 1;
			if (hideCount === 0) {
				device.showNavbar(true).catch(() => {});
			}
		};
	}, [open]);

	return isAndroidApp ? open && navbarHidden : open;
};
